import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const blaze = definePartsStyle({
  control: {
    borderColor: "transparent.white.30",
    _checked: {
      bg: "blaze.blaze",
      borderColor: "blaze.blaze",
      _hover: {
        bg: "blaze.blaze",
        borderColor: "blaze.blaze",
      },
    },
  },
});

export const checkboxTheme = defineMultiStyleConfig({
  variants: {
    blaze,
  },
});
